import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { ChartsContext } from "./ChartsContext";
import { Box, CircularProgress, Typography } from "@mui/material";

/**
 * Componente que redirige automáticamente según el tipo de survey:
 * - Surveys con template → overview
 * - Surveys custom (sin template) → questions-data
 */
export function ChartRedirect(): JSX.Element {
  const { survey, isLoading } = useContext(ChartsContext);

  // Esperar a que la survey se cargue con un spinner visual
  if (isLoading || !survey || !survey.id) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        minHeight="60vh"
        paddingTop="80px"
        gap={2}
      >
        <CircularProgress size={40} thickness={4} />
        <Typography variant="h6" color="primary" fontFamily="IBM Plex Sans">
          Loading survey...
        </Typography>
      </Box>
    );
  }

  // Si tiene templateName definido, va a overview
  // Si no tiene templateName o está vacío, va a questions-data
  const hasTemplate = survey.templateName && survey.templateName.trim() !== "";
  const destination = hasTemplate ? "overview" : "questions-data";

  return <Navigate to={destination} replace />;
}
